import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux";
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next";
import TabNavigation from "components/tablink/tablink"
import classnames from "classnames"
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";

import {
  getLeadDetail, convertLeadIntoClient,
  convertLeadIntoContact,
} from "../../../store/actions";
import {
   Col, Row, Card, CardBody, Table, FormGroup, Label, Button, ButtonGroup,
  InputGroup, Offcanvas, OffcanvasHeader, OffcanvasBody, Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import RsLink from "components/buttons/rsLink";
import moment from "moment-timezone";
import buyer from "../questions/buyer";
import { Callbacks } from "jquery";
import SafeField from "helpers/SafeField";
import { hasPermission } from "helpers/checkPermission";
import { API_URL } from 'helpers/app_url';
import axios from "axios"

class LeadDetailMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
       isTransferLead: false,
      isRTransferLead: false,
      activeTab: "2",
      verticalActiveTab: "1",
      activeTab1: "1",
      activeTab2: "4",
      agents: [],
    }


    this.toggleRightCanvas2 = this.toggleRightCanvas2.bind(this);
    this.toggleRightCanvas3 = this.toggleRightCanvas3.bind(this);
    this.toggleTransferLead = this.toggleTransferLead.bind(this);
    this.toggleRTransferLead = this.toggleRTransferLead.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
      this.toggle2 = this.toggle2.bind(this);
    this.toggle1 = this.toggle1.bind(this);
  }
toggle1(tab) {
    if (this.state.activeTab1 !== tab) {
      this.setState({
        activeTab1: tab,
      });
    }
  }

  toggle2(tab) {
    if (this.state.activeTab2 !== tab) {
      this.setState({
        activeTab2: tab,
      });
    }
  }

  toggleRightCanvas2() {
    this.setState({ isRight2: !this.state.isRight2 });
  }

  toggleRightCanvas3() {
    this.setState({ isRight3: !this.state.isRight3 });
  }

  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  handleOnChange = value => {
    this.setState({
      volume: value,
    });
  };
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  cctoggle(tab) {
    if (this.state.ccTab !== tab) {
      this.setState({
        ccTab: tab,
      });
    }
  }
  toggleTransferLead() {
    this.setState({ isTransferLead: !this.state.isTransferLead });
  }

  toggleRTransferLead() {
    this.setState({ isRTransferLead: !this.state.isRTransferLead });
  }

  componentDidMount() {

    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;

    axios.get(`${API_URL}AgentExt/AllAgentByOffice`, {
      params: {
        clientId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ agents: res.data });
      })
    //console.log(this.props.campleads)
  }
  render() {
    const { leads, onConvertLeadToClient, onCovertLeadIntoContact } = this.props;
    const { agents } = this.state;
     const updatedList = agents.filter(item => item.id !== leads.agentId);
    const navItems = [
      {
        id: 'lead-detail',
        label: 'Activities',
        link: `/lead/lead-detail/${this.props.match.params.id}/${this.props.match.params.leadId}`
      }
    ];
    if (!leads?.onlyInterestedPreConsProject) {
      navItems.push(
        {
          id: 'buyer-preference',
          label: 'Buying Profile',
          link: `/lead/buyer-preference/${this.props.match.params.id}/${this.props.match.params.leadId}`
        },
        {
          id: 'buyer-eligibility',
          label: 'Eligibility Score',
          link: `/lead/buyer-eligibility/${this.props.match.params.id}/${this.props.match.params.leadId}`
        },
        {
          id: 'selling-preferences',
          label: 'Selling Profile',
          link: `/lead/selling-preferences/${this.props.match.params.id}/${this.props.match.params.leadId}`
        }
      );
    }
    return (
      <React.Fragment>

        <Row style={{ marginTop: 20, paddingLeft: 10, marginBottom: 20 }}>
          <Col sm="12">
            {hasPermission("RealtorLeads", "ConvertToContact") && (
              <>
                {leads?.clientLinking?.contactId < 1 ? (

                  <RsLink onClick={this.toggleRightCanvas3} className="btn-light-sm border-blue w-md me-2" iconClass="">Save as Contact</RsLink>

                ) : (
                  <RsLink onClick={this.toggleRightCanvas3} className="btn-light-sm border-blue w-md disabled me-2" iconClass="bx bx-check">Save as Contact</RsLink>
                )}
              </>
            )}
            {hasPermission("RealtorLeads", "ConvertToClient") && (
              <>
                {leads?.clientLinking?.clientId < 1 ? (
                  <RsLink
                    onClick={this.toggleRightCanvas2}
                    className="btn-light-sm border-green w-md me-2"
                    iconClass=""
                  >
                    Save as Client
                  </RsLink>
                ) : (
                  <RsLink
                    onClick={this.toggleRightCanvas2}
                    className="btn-light-sm border-green w-md disabled me-2"
                    iconClass="bx bx-check"
                  >
                    Save as Client
                  </RsLink>
                )}
              </>
            )}


            <>
              {(leads?.isTransfered === true && leads?.onlyInterestedPreConsProject == false) ? (
                <RsLink
                  onClick={this.toggleRTransferLead}
                  className="btn-light-sm border-green w-md"
                  iconClass=""
                >
                  Re-Assign to Agent
                </RsLink>
              ) :
                leads?.onlyInterestedPreConsProject == false ? (
                  <RsLink
                    onClick={this.toggleTransferLead}
                    className="btn-light-sm border-green w-md"
                    iconClass=""
                  >
                    Assign to Agent
                  </RsLink>
                ) : (
                  <></>
                )}
            </>
          </Col>
        </Row>
        <TabNavigation navItems={navItems}

        />
        <Offcanvas
          isOpen={this.state.isRight2}
          direction="end"
          toggle={this.toggleRightCanvas2}
          style={{ width: "600px" }}
        >
          <OffcanvasHeader toggle={this.toggleRightCanvas2}>
            Create Client
          </OffcanvasHeader>
          <OffcanvasBody>
            <p className="font-size-15"><strong>Profile Info</strong></p>


            <p className="form-label">
              Name : {leads.firstName + " " + leads.lastName}{" "}
            </p>

            <hr />
            <p className="font-size-15"><strong>
              Type of Client </strong>(<small>Check all that apply</small>)
            </p>
            {/* <h5  >Check all that apply</h5> */}
            <Formik
              enableReinitialize={true}
              initialValues={{

                linkingId: 0,
                contactId: 0,
                leadId: leads.id,
                leadUUid: leads.leadId,
                clientId: 0,
                isBuyer: false,
                isSeller: false,
                isInvestor: false,
                buyerType: '',
                sellerType: '',
                lastAgreementDate: new Date(),
                userName: '',
                clientEngagementStatus: 1,
                commissionTypeId: '',
                commissionValue: '',
                sellerCommissionTypeId: '',
                sellerCommissionValue: '',
                sellerLastAgreementDate: new Date(),
                investorLastAgreementDate: new Date(),
                buyerStartDate: null,
                buyerEndDate: null,
                sellerStartDate: null,
                sellerEndDate: null,
                skipLoginCreation: false,
                agentId: parseInt(localStorage.getItem('userId')),
              }}

              validationSchema={Yup.object().shape({
                skipLoginCreation: Yup.boolean(),
                userName: Yup.string().when("skipLoginCreation", {
                  is: false,
                  then: (schema) =>
                    schema
                      .email("Invalid email format")
                      .required("Email is required"),
                  otherwise: (schema) => schema.notRequired().nullable(),
                }),

                confirmEmail: Yup.string().when("skipLoginCreation", {
                  is: false,
                  then: (schema) =>
                    schema
                      .email("Invalid email format")
                      .oneOf([Yup.ref("userName")], "Emails must match")
                      .required("Please confirm your email"),
                }),

                // For Buyer fields
                buyerType: Yup.number().when("isBuyer", {
                  is: true,
                  then: Yup.number()
                    .required("Please select Buyer Type")
                    .min(1, "Please select Buyer Type"),
                }),

                commissionTypeId: Yup.number().when(["isBuyer", "buyerType"], {
                  is: (isBuyer, buyerType) => isBuyer && (buyerType == 1 || buyerType == 2),
                  then: Yup.number()
                    .required("Commission Type is required")
                    .min(1, "Commission Type is required"),
                }),

                commissionValue: Yup.number().when(["isBuyer", "buyerType"], {
                  is: (isBuyer, buyerType) => isBuyer && (buyerType == 1 || buyerType == 2),
                  then: Yup.number()
                    .required("Commission Value is required")
                    .moreThan(0, "Commission Value must be greater than 0"),
                }),

                buyerStartDate: Yup.date().when(["isBuyer", "buyerType"], {
                  is: (isBuyer, buyerType) => isBuyer && buyerType == 1, // Rent
                  then: Yup.date().required("Start Date is required"),
                }),

                buyerEndDate: Yup.date().when(["isBuyer", "buyerType"], {
                  is: (isBuyer, buyerType) => isBuyer && buyerType == 1, // Rent
                  then: Yup.date()
                    .required("End Date is required")
                    .min(Yup.ref("buyerStartDate"), "End Date must be after Start Date"),
                })
              })}
              onSubmit={values => {
                const updateData = {
                  linkingId: values.linkingId,
                  contactId: values.contactId,
                  leadId: parseInt(values.leadId),
                  leadUUid: values.leadUUid,
                  clientId: values.clientId,
                  isBuyer: values.isBuyer ? true : false,
                  isSeller: values.isSeller ? true : false,
                  isInvestor: values.isInvestor ? true : false,
                  buyerType: values.buyerType ? parseInt(values.buyerType) : 0,
                  sellerType: values.sellerType ? parseInt(values.sellerType) : 0,
                  lastAgreementDate: moment(values.lastAgreementDate).format('YYYY-MM-DD'),
                  userName: values.userName,
                  clientEngagementStatus: values.clientEngagementStatus ? parseInt(values.clientEngagementStatus) : 0,
                  commissionTypeId: values.commissionTypeId ? parseInt(values.commissionTypeId) : 0,
                  commissionValue: values.commissionValue ? parseInt(values.commissionValue) : 0,

                  sellerCommissionTypeId: values.sellerCommissionTypeId ? parseInt(values.sellerCommissionTypeId) : 0,
                  sellerCommissionValue: values.sellerCommissionValue ? parseInt(values.sellerCommissionValue) : 0,
                  sellerLastAgreementDate: moment(values.sellerLastAgreementDate).format('YYYY-MM-DD'),

                  investorLastAgreementDate: moment(values.investorLastAgreementDate).format('YYYY-MM-DD'),
                  buyerStartDate: values.buyerStartDate ? moment(values.buyerStartDate).format('YYYY-MM-DD') : null,
                  buyerEndDate: values.buyerEndDate ? moment(values.buyerEndDate).format('YYYY-MM-DD') : null,
                  sellerStartDate: values.sellerStartDate ? moment(values.sellerStartDate).format('YYYY-MM-DD') : null,
                  sellerEndDate: values.sellerEndDate ? moment(values.sellerEndDate).format('YYYY-MM-DD') : null,
                  skipLoginCreation: values.skipLoginCreation,
                  agentId: parseInt(localStorage.getItem('userId'))

                };
                //console.log(updateData);
                onConvertLeadToClient(updateData, (status) => {
                  if (status === true) {
                    this.toggleRightCanvas2();
                  }
                });
              }}
            >
              {({
                errors,
                touched,
                values,
                handleChange,
                setFieldValue,
                setFieldTouched
              }) => (
                <Form className="needs-validation">
                  {/* <FormGroup className="mb-3"> */}
                  <Row>
                    <Col sm="12">
                      <div className="d-flex justify-content-between mb-1">
                        <div>
                          <Field
                            name="isBuyer"
                            className="form-check-input me-2 offcanvas-chk-box"
                            type="checkbox"
                            id="isBuyer"
                            onChange={handleChange}
                          />
                          <Label
                            htmlFor="isBuyer"
                            className="form-check-label"
                          >
                            {this.props.t("Buyer")}
                          </Label>
                        </div>

                        {/* </FormGroup> */}
                      </div>
                    </Col>
                    {values.isBuyer && (
                      <Col sm="12" className="mt-2">
                        <div className="form-check form-check-inline">
                          <label className="form-label"><strong>Select type</strong></label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" onChange={handleChange} name="buyerType" id="btnradio4" value="1" />
                          <label className="form-check-label" htmlFor="btnradio4">Rent</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" onChange={handleChange} name="buyerType" id="btnradio5" value="2" />
                          <label className="form-check-label" htmlFor="btnradio5">Purchase</label>
                        </div>
                        {errors.buyerType && touched.buyerType && (
                          <div className="invalid-feedback d-block">{errors.buyerType}</div>
                        )}

                        <div style={{ height: 15 }}></div>
                      </Col>
                    )}
                  </Row>

                  {values.isBuyer && (
                    <>
                      <Row>
                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="commissionTypeId">{this.props.t("Commission Type")}</Label>
                            <SafeField as="select" name="commissionTypeId"
                              className={
                                "form-control" +
                                (errors.commissionTypeId && touched.commissionTypeId
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value="">Select</option>
                              <option value="4">Percentage</option>
                              <option value="3">Fixed</option>

                            </SafeField>
                            <ErrorMessage name="commissionTypeId" component="div" className="invalid-feedback" />
                          </FormGroup>
                        </Col>

                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="commissionValue">{this.props.t("Commission Value")}</Label>
                            <SafeField type="text" name="commissionValue"
                              className={
                                "form-control" +
                                (errors.commissionValue && touched.commissionValue
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage name="commissionValue" component="div" className="invalid-feedback" />
                          </FormGroup>
                        </Col>

                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="lastAgreementDate">
                              {this.props.t("Agreement Date")}
                            </Label>
                            <InputGroup>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.lastAgreementDate && touched.lastAgreementDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.lastAgreementDate}
                                onChange={value =>
                                  setFieldValue("lastAgreementDate", value[0])
                                }
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                }}
                              />
                              <div className="input-group-append">
                                <span className="input-group-text">
                                  <i className="mdi mdi-clock-outline" />
                                </span>
                              </div>
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                      {values.buyerType == 1 && (
                        <Row>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="buyerStartDate">
                                {this.props.t("Tentative start date")}
                              </Label>
                              <InputGroup>
                                <Flatpickr
                                  name="buyerStartDate"
                                  className={
                                    "form-control" +
                                    (errors.buyerStartDate && touched.buyerStartDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder=""
                                  value={values.buyerStartDate || ""}
                                  onChange={value =>
                                    setFieldValue("buyerStartDate", value[0])
                                  }
                                  onClose={() => setFieldTouched("buyerStartDate", true)}
                                  options={{
                                    altInput: false,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                    minDate: 'today'
                                  }}
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <i className="mdi mdi-clock-outline" />
                                  </span>
                                </div>
                              </InputGroup>
                              <ErrorMessage
                                name="buyerStartDate"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="buyerEndDate">
                                {this.props.t("Tentative End date")}
                              </Label>
                              <InputGroup>
                                <Flatpickr
                                  name="buyerEndDate"
                                  className={
                                    "form-control" +
                                    (errors.buyerEndDate && touched.buyerEndDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder=""
                                  //value={values.buyerStartDate || ""}
                                  onChange={value =>
                                    setFieldValue("buyerEndDate", value[0])
                                  }
                                  options={{
                                    altInput: false,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                    minDate: values.buyerStartDate || null,
                                  }}
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <i className="mdi mdi-clock-outline" />
                                  </span>
                                </div>
                              </InputGroup>
                              <ErrorMessage name="buyerEndDate" component="div" className="invalid-feedback" />
                            </FormGroup>
                          </Col>
                        </Row>

                      )}
                    </>
                  )}

                  <Row>
                    <Col sm="12">
                      <div className="d-flex justify-content-between mb-1">
                        <div>
                          <Field
                            name="isSeller"
                            className="form-check-input me-2 offcanvas-chk-box"
                            type="checkbox"
                            id="isSeller"
                            onChange={handleChange}
                          // checked='true'
                          />
                          <Label
                            htmlFor="isSeller"
                            className="form-check-label"
                          >
                            {this.props.t("Seller")}
                          </Label>
                        </div>

                        {/* </FormGroup> */}
                      </div>
                    </Col>
                    {values.isSeller && (
                      <Col sm="12">
                        <div className="form-check form-check-inline">
                          <label className="form-label"><strong>Select type</strong></label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" onChange={handleChange} name="sellerType" id="btnradio6" value="1" />
                          <label className="form-check-label" htmlFor="btnradio6">Sell</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" onChange={handleChange} name="sellerType" id="btnradio7" value="2" />
                          <label className="form-check-label" htmlFor="btnradio7">Lease</label>
                        </div>
                        <div style={{ height: 15 }}></div>
                      </Col>
                    )}
                  </Row>

                  {values.isSeller && (
                    <>
                      <Row>
                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="sellerCommissionTypeId">{this.props.t("Commission Type")}</Label>
                            <SafeField as="select" name="sellerCommissionTypeId" className="form-control">
                              <option value="">Select</option>
                              <option value="4">Percentage</option>
                              <option value="3">Fixed</option>

                            </SafeField>
                            <ErrorMessage name="sellerCommissionTypeId" component="div" className="invalid-feedback" />
                          </FormGroup>
                        </Col>

                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="sellerCommissionValue">{this.props.t("Commission Value")}</Label>
                            <SafeField type="text" name="sellerCommissionValue" className="form-control" />
                            <ErrorMessage name="sellerCommissionValue" component="div" className="invalid-feedback" />
                          </FormGroup>
                        </Col>

                        <Col sm="4">
                          <FormGroup className="mb-3">
                            <Label htmlFor="sellerLastAgreementDate">
                              {this.props.t("Agreement Date")}
                            </Label>
                            <InputGroup>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.sellerLastAgreementDate && touched.sellerLastAgreementDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.sellerLastAgreementDate}
                                onChange={value =>
                                  setFieldValue("sellerLastAgreementDate", value[0])
                                }
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                }}
                              />
                              <div className="input-group-append">
                                <span className="input-group-text">
                                  <i className="mdi mdi-clock-outline" />
                                </span>
                              </div>
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                      {values.sellerType == 2 && (
                        <Row>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="sellerStartDate">
                                {this.props.t("Tentative start date")}
                              </Label>
                              <InputGroup>
                                <Flatpickr
                                  className={
                                    "form-control" +
                                    (errors.sellerStartDate && touched.sellerStartDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder=""
                                  value=""
                                  onChange={value =>
                                    setFieldValue("sellerStartDate", value[0])
                                  }
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <i className="mdi mdi-clock-outline" />
                                  </span>
                                </div>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="sellerEndDate">
                                {this.props.t("Tentative End date")}
                              </Label>
                              <InputGroup>
                                <Flatpickr
                                  className={
                                    "form-control" +
                                    (errors.sellerEndDate && touched.sellerEndDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder=""
                                  value=""
                                  onChange={value =>
                                    setFieldValue("sellerEndDate", value[0])
                                  }
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <i className="mdi mdi-clock-outline" />
                                  </span>
                                </div>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>

                      )}
                    </>
                  )}


                  <FormGroup className="mb-3">
                    <Field
                      name="isInvestor"
                      className="form-check-input me-2 offcanvas-chk-box"
                      type="checkbox"
                      id="isInvestor"
                      onChange={handleChange}
                    // checked='true'
                    />
                    <Label
                      htmlFor="isInvestor"
                      className="form-check-label"
                    >
                      {this.props.t("Investor")}
                    </Label>
                  </FormGroup>
                  {values.isInvestor && (
                    <Row>


                      <Col sm="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="investorLastAgreementDate">
                            {this.props.t("Agreement Date")}
                          </Label>
                          <InputGroup>
                            <Flatpickr
                              className={
                                "form-control" +
                                (errors.investorLastAgreementDate && touched.investorLastAgreementDate
                                  ? " is-invalid"
                                  : "")
                              }
                              placeholder=""
                              value={values.investorLastAgreementDate}
                              onChange={value =>
                                setFieldValue("investorLastAgreementDate", value[0])
                              }
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                              }}
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <i className="mdi mdi-clock-outline" />
                              </span>
                            </div>
                          </InputGroup>
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                  <Col sm="12">
                    <div className="form-check mb-3">
                      <Field
                        type="checkbox"
                        name="skipLoginCreation"
                        className="form-check-input offcanvas-chk-box me-2"
                        id="skipLoginCreation"
                      />
                      <label
                        htmlFor="skipLoginCreation"
                        className="form-check-label form-label"
                      >
                        Skip login creation
                      </label>
                      <ErrorMessage
                        name="skipLoginCreation"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                  {values.skipLoginCreation == false && (
                    <>
                      <p className="font-size-15"><strong>
                        Client Login Info</strong>
                      </p>
                      <FormGroup className="mb-3">
                        <Label htmlFor="userName">
                          {this.props.t("Login email ( The login email cannot be changed at a later date)")}
                        </Label>
                        <SafeField
                          name="userName"
                          type="text"
                          place
                          // placeholder="Login email"
                          //value={values.referedBy}
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.userName && touched.userName
                              ? " is-invalid"
                              : "")
                          }
                          id="userName"
                        />
                        <ErrorMessage
                          name="userName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>

                      <FormGroup className="mb-3">
                        <Label htmlFor="confirmEmail">
                          {this.props.t("Confirm email")}
                        </Label>
                        <SafeField
                          name="confirmEmail"
                          type="text"
                          //value={values.referedBy}
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.confirmEmail && touched.confirmEmail
                              ? " is-invalid"
                              : "")
                          }
                          id="confirmEmail"
                        />
                        <ErrorMessage
                          name="confirmEmail"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>

                      <p className="offcanvas-info">
                        A system generated password is sent to the client
                      </p>
                    </>
                  )}
                  <div>
                    <button
                      type="submit"
                      className="btn btn-primary w-md"
                    >
                      Convert{" "}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>

          </OffcanvasBody>
        </Offcanvas>
        <Offcanvas
          isOpen={this.state.isRight3}
          direction="end"
          toggle={this.toggleRightCanvas3}
        >
          <OffcanvasHeader toggle={this.toggleRightCanvas3}>
            Convert to Contact
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                leadId: leads.id,
                linkingId: 0,
                contactId: 0,
                leadUUid: leads.leadId,
                contactTypeId: '',
                contactFrequency: "",
                contactIsVendor: false,
                agentId: parseInt(localStorage.getItem('userId')),
              }}
              validationSchema={Yup.object().shape({
                contactTypeId: Yup.number()
                  .required('This is required'),

                contactFrequency: Yup.string()
                  .required('This is required')

              })}
              onSubmit={values => {
                const updateData = {
                  leadId: parseInt(values.leadId),
                  leadUUid: values.leadUUid,
                  linkingId: values.linkingId,
                  contactId: values.contactId,
                  contactTypeId: parseInt(values.contactTypeId),
                  contactFrequency: values.contactFrequency,
                  contactIsVendor: values.contactIsVendor ? true : false,
                  agentId: parseInt(localStorage.getItem('userId')),
                };
                onCovertLeadIntoContact(updateData, (status) => {
                  if (status === true) {
                    this.toggleRightCanvas3();
                  }
                });
              }}
            >
              {({
                errors,
                touched,
                values,
                handleChange,
                setFieldValue,
              }) => (
                <Form className="needs-validation">


                  <FormGroup className="mb-3">
                    <Label htmlFor="name">{this.props.t("Name")}</Label>

                    <SafeField
                      name="name"
                      type="text"
                      value={leads.firstName + " " + leads.lastName}


                      className="form-control"
                      id="name"
                      disabled
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label
                      htmlFor="type"
                      className="form-label label-text"
                    >
                      Type *
                    </Label>
                    <SafeField
                      as="select"
                      className={
                        "form-control" +
                        (errors.contactTypeId && touched.contactTypeId
                          ? " is-invalid"
                          : "")
                      }
                      name="contactTypeId"
                      id="type"
                    >
                      <option value="">Select</option>
                      <option value="1">Silver </option>
                      <option value="2">Gold</option>
                      <option value="1">VIP</option>
                    </SafeField>
                    <ErrorMessage
                      name="contactTypeId"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label
                      htmlFor="contactFrequency"
                      className="form-label label-text"
                    >
                      Contact frequency *
                    </Label>
                    <SafeField
                      as="select"
                      className={
                        "form-control" +
                        (errors.contactFrequency && touched.contactFrequency
                          ? " is-invalid"
                          : "")
                      }
                      name="contactFrequency"
                      id="frequency"
                    >
                      <option value="">Select</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Quarterly">Quarterly</option>
                      <option value="Semi-annual">Semi-annual</option>
                      <option value="Annual">Annual</option>
                    </SafeField>
                    <ErrorMessage
                      name="contactFrequency"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <SafeField
                      name="contactIsVendor"
                      className="form-check-input me-2 offcanvas-chk-box"
                      type="checkbox"
                      id="contactIsVendor"
                      onClick={e => handleChange(e)}
                    // checked='true'
                    />
                    <Label
                      htmlFor="contactIsVendor"
                      className="form-check-label"
                    >
                      {this.props.t("Is a Vendor")}
                    </Label>
                  </FormGroup>

                  <div>
                    <button
                      type="submit"
                      className="btn btn-primary w-md"
                    >
                      Convert{" "}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>
          <Offcanvas
          isOpen={this.state.isTransferLead}
          direction="end"
          toggle={this.toggleTransferLead}
        >
          <OffcanvasHeader toggle={this.toggleTransferLead}>
            Assign to Agent
          </OffcanvasHeader>
          <OffcanvasBody>
            <div className="tabContent">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  agentId: ''
                }}
                validationSchema={Yup.object().shape({
                  agentId: Yup.string().required("This is required"),
                })}

                onSubmit={values => {

                  const obj = JSON.parse(localStorage.getItem("authUser"));
                  const token = obj.resultData.bearerToken;
                  const str = 'Bearer ' + token;

                  const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': str
                  };
                  var id = parseInt(this.props.match.params.id);
                  var leadId = this.props.match.params.leadId;
                  var isTransfered = true;
                  var brokerId = parseInt(localStorage.getItem("userId"));
                  var agentId = parseInt(values.agentId);
                  var brokerFullId = leadId;
                  var agentFullId = leadId;
                  const body = {
                    id,
                    leadId,
                    agentId,
                    brokerId,
                    isTransfered,
                    brokerFullId,
                    agentFullId
                  }

                  try {
                    this.toggleTransferLead();
                    toast.loading("Please wait...");
                    axios.post(`${API_URL}BrokerLead/TransferBrokerLead`, body, { headers })
                      .then(response => {
                        toast.dismiss();
                        toast.success("Lead Assigned Successfully!");
                        //allProjectOpenHouseData(localStorage.getItem('userId'), this.props.match.params.projectId);
                        //location.reload();
                      })
                      .catch(error => {
                        toast.dismiss();
                        toast.success("Err :" + error);
                      });
                  } catch (error) {
                    toast.dismiss();
                    toast.success("Err :" + error);
                  }
                }}
              >
                {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                  <Form
                    className="needs-validation"
                  >
                    <Row>

                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="agentId">
                            Agent Name
                          </Label>
                          <Field as="select" name="agentId"
                            className={
                              "form-control" +
                              (errors.agentId && touched.agentId
                                ? " is-invalid"
                                : "")
                            }
                            onChange={handleChange}>
                            <option value="">Select</option>
                            {
                              this.state.agents
                                .map(agents =>
                                  <option key={agents.id} value={agents.id}>{agents.firstName}</option>
                                )
                            }
                          </Field>
                          <ErrorMessage
                            name="agentId"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>

                      </Col>
                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Assign Agent</button></div>

                    </Row>
                  </Form>
                )}
              </Formik>
            </div>
          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isRTransferLead}
          direction="end"
          toggle={this.toggleRTransferLead}
        >
          <OffcanvasHeader toggle={this.toggleRTransferLead}>
            Re-Assign to Agent
          </OffcanvasHeader>
          <OffcanvasBody>
            <Nav pills className="navtab-bg nav-justified">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "1",
                  })}
                  onClick={() => {
                    this.toggle1("1");
                  }}
                >
                  <i className="grid-icon  bx bx-message-alt grid-iconSize"><span className="tabSelected"> Assigned Agent</span></i>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "2",
                  })}
                  onClick={() => {
                    this.toggle1("2");
                  }}
                >
                  <i className="grid-icon  bx bx-user-voice grid-iconSize"><span className="tabSelected"> Assign New Agent</span></i>

                </NavLink>
              </NavItem>
            </Nav>
            <TabContent
              activeTab={this.state.activeTab1}
              className="p-3 text-muted"
            >
              <TabPane tabId="1">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      agentId: leads.agentId
                    }}
                    validationSchema={Yup.object().shape({

                    })}

                    onSubmit={values => {
                    }
                    }
                  >
                    {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >
                        <Row>

                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="agentId">
                                Agent Name
                              </Label>
                              <Field as="select" disabled name="agentId"
                                className={
                                  "form-control" +
                                  (errors.agentId && touched.agentId
                                    ? " is-invalid"
                                    : "")
                                }
                                onChange={handleChange}>
                                <option value="">Select</option>
                                {
                                  this.state.agents
                                    .map(agents =>
                                      <option key={agents.id} value={agents.id}>{agents.firstName}</option>
                                    )
                                }
                              </Field>
                              <ErrorMessage
                                name="agentId"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>
                          {/* <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Transfer</button></div>
 */}
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </div>
              </TabPane>
              <TabPane tabId="2">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      agentId: ''
                    }}
                    validationSchema={Yup.object().shape({
                      agentId: Yup.string().required("This is required"),
                    })}

                    onSubmit={values => {

                      const obj = JSON.parse(localStorage.getItem("authUser"));
                      const token = obj.resultData.bearerToken;
                      const str = 'Bearer ' + token;

                      const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': str
                      };
                      var id = parseInt(this.props.match.params.id);
                      var leadId = this.props.match.params.leadId;
                      var isTransfered = true;
                      var brokerId = parseInt(localStorage.getItem("userId"));
                      var agentId = parseInt(values.agentId);
                      var brokerFullId = leadId;
                      var agentFullId = leadId;
                      const body = {
                        id,
                        leadId,
                        agentId,
                        brokerId,
                        isTransfered,
                        brokerFullId,
                        agentFullId
                      }

                      try {
                        this.toggleRTransferLead();
                        toast.loading("Please wait...");
                        axios.post(`${API_URL}BrokerLead/TransferBrokerLead`, body, { headers })
                          .then(response => {
                            toast.dismiss();
                            toast.success("Lead Assigned Successfully!");
                            //allProjectOpenHouseData(localStorage.getItem('userId'), this.props.match.params.projectId);
                            //location.reload();
                          })
                          .catch(error => {
                            toast.dismiss();
                            toast.success("Err :" + error);
                          });
                      } catch (error) {
                        toast.dismiss();
                        toast.success("Err :" + error);
                      }
                    }}
                  >
                    {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >
                        <Row>

                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="agentId">
                                Agent Name
                              </Label>
                              <Field as="select" name="agentId"
                                className={
                                  "form-control" +
                                  (errors.agentId && touched.agentId
                                    ? " is-invalid"
                                    : "")
                                }
                                onChange={handleChange}>
                                <option value="">Select</option>
                                {
                                  updatedList
                                    .map(agents =>
                                      <option key={agents.id} value={agents.id}>{agents.firstName}</option>
                                    )
                                }
                              </Field>
                              <ErrorMessage
                                name="agentId"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>
                          <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Assign Agent</button></div>

                        </Row>
                      </Form>
                    )}
                  </Formik>
                </div>
              </TabPane>

            </TabContent>

          </OffcanvasBody>
        </Offcanvas>
      </React.Fragment>
    )
  }
}
LeadDetailMenu.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  onConvertLeadToClient: PropTypes.func,
  onCovertLeadIntoContact: PropTypes.func,
  leads: PropTypes.object
}


const mapDispatchToProps = dispatch => ({
  onConvertLeadToClient: (data, Callback) => dispatch(convertLeadIntoClient(data, Callback)),
  onCovertLeadIntoContact: (data, Callback) => dispatch(convertLeadIntoContact(data, Callback)),
});
export default withRouter(connect('', mapDispatchToProps)(withTranslation()((LeadDetailMenu))))
